export const APPCLOSE_URL = 'https://appclose.com';
export const APPCLOSE_WEB_URL = 'https://web.appclose.com';
export const APPCLOSE_PRO_URL = 'https://appclose.com/pro';
export const SUPPORT_URL = 'https://support.appclose.com';
export const FAMILY_COURT_SERVICE_URL =
  'https://appclose.com/pro/request-brochures/?source=header';
export const ACCESS_CERTIFIED_RECORDS_URL =
  'https://appclose.com/pro/access-certified-records/?source=header';
export const EMAIL_SUPPORT_URL =
  'mailto:support@appclose.com?subject=AppClose%20Support';
export const IPAY_YOU_LEARN_MORE_URL =
  'https://support.appclose.com/hc/en-us/sections/27436090978587-IPAYOU-PAYMENT-SOLUTION-FOR-CO-PARENTS';
export const APPCLOSE_SOLO_URL =
  'https://support.appclose.com/hc/en-us/sections/360002288373';
export const APP_APPSTORE_LINK_URL =
  'https://apps.apple.com/us/app/appclose/id1019290876';
export const APP_PLAYSTORE_LINK_URL =
  'https://play.google.com/store/apps/details?id=com.appclose.androidapp';

export const APPCLOSE_FACEBOOK_URL = 'https://facebook.com/appcloseusa';
export const APPCLOSE_X_URL = 'https://x.com/appcloseusa';
export const APPCLOSE_INSTAGRAM_URL = 'https://www.instagram.com/appclose/';

export const ABOUT_US = 'https://appclose.com/about.html';

export const PRO_SUBPOENA_POLICY_URL =
  'https://appclose.com/info/AppClose-Subpoena-Response-Policy.pdf';
export const PRO_SUPPORT_URL = 'https://support.appclose.com/';
export const PRO_TERMS_OF_SERVICE = 'https://appclose.com/terms-pro.html';
export const PRO_PRIVACY_POLICY = 'https://appclose.com/privacy.html';

export const BEST_IN_BUSINESS = 'https://www.inc.com/best-in-business';
export const OPERATIONAL_EXCELLENCE =
  'https://www.inc.com/best-in-business/2024/operational-excellence';

export const DWOLLA_NETWORK =
  'https://www.dwolla.com/legal/about-our-financial-institution-partners';

export const DWOLLA_SECURITY = 'https://www.dwolla.com/features/security';

export const FEEWAIVER_URL = 'https://web.appclose.com/feewaiver';

export const NAV_LINKS = {
  CO_PARENT_ASSIST: '/co-parent-assist',
  PRICING: '/pricing',
  PRIVACY: '/privacy',
  REFUND_POLICY: '/refund-policy',
  TERMS: '/terms',
};
